const API_CONFIG = {
  apiURL: process.env.REACT_APP_ZDASH_URL,
  apiRedirectURL: process.env.REACT_APP_REDIRECT_URL,
  isSmallBusinessSign: process.env.REACT_APP_SIGN_UP_TYPE === 'SMALL_BUSINESS',
  publishableKey: process.env.REACT_APP_STRIPE_API_KEY,
};

export const DIGITAL_PLAN_KEY = API_CONFIG.isSmallBusinessSign ? 'digital_join_now' : 'digital';
export const PRO_QSR_PLAN_KEY = API_CONFIG.isSmallBusinessSign ? 'pro_qsr_join_now' : 'pro_qsr';
export const ESSENTIALS_FOOD_TRUCK_PLAN_KEY = API_CONFIG.isSmallBusinessSign ? 'essentials_food_truck_join_now' : 'essentials_food_truck';
export const ESSENTIALS_QSR_PLAN_KEY = API_CONFIG.isSmallBusinessSign ? 'essentials_qsr_join_now' : 'essentials_qsr';
export const PRO_FOOD_TRUCK_PLAN_KEY = API_CONFIG.isSmallBusinessSign ? 'pro_food_truck_join_now' : 'pro_food_truck';

export default API_CONFIG;